import { AccountScreen } from '../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <AccountScreen />;
}
